module.exports = __webpack_public_path__ + "img/Last image OOBE Italian.54a7ff75.png";